import request from '@/utils/request.js'
import Vue from 'vue'

/** 订单 ↓ **/
//我的订单
export function orderList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/order/queryShopsOrderList',
    method: 'GET',
    params: query
  })
}

//预备提交订单
export function preReady (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/orderConfirm',
    method: 'POST',
    data: query
  })
}

//提交订单
export function createOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/submitOrders',
    method: 'POST',
    data: query
  })
}

//订单详情
export function orderDetail (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/order/getShopsOrderInfo',
    method: 'get',
    params: query
  })
}

//确认收货
export function editMyOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/order/editOrder',
    method: 'POST',
    data: query
  })
}

//订单详情
export function orderDetailFee (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/fee/order/queryById',
    method: 'get',
    params: query
  })
}

//订单详情-收货
export function getShopsDeliveryInfo (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/delivery/order/getShopsDeliveryInfo',
    method: 'get',
    params: query
  })
}

//订单详情
export function returnDetail (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/return/queryById',
    method: 'get',
    params: query
  })
}

//订单物料详情
export function itemDetail (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/itemDetail',
    method: 'GET',
    params: query
  })
}

//确认收货
export function confirmOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/confirm',
    method: 'POST',
    data: query
  })
}

//取消订单
export function cancelOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/order/cancel',
    method: 'POST',
    data: query,
  })
}

//评价物料
export function commentGoods (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/comment',
    method: 'POST',
    data: query,
  })
}

//申请售后
export function aftersale (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_aftersale/aftersale',
    method: 'POST',
    data: query
  })
}

//售后列表
export function aftersaleList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_aftersale/index',
    method: 'GET',
    params: query
  })
}

//售后列表详情
export function aftersaleDetail (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_aftersale/detail',
    method: 'GET',
    params: query,
  })
}

//删除订单
export function delOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/delete',
    method: 'POST',
    data: query
  })
}

//删除售后订单
export function delAftersaleOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_aftersale/delete',
    method: 'POST',
    data: query
  })
}

//取消售后订单
export function cancelAftersaleOrder (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_aftersale/cancel',
    method: 'POST',
    data: query
  })
}

//快递列表
export function expressList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_express/index',
    method: 'GET',
    params: query
  })
}

//包裹详情
export function expressDetail (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order_express/detail',
    method: 'GET',
    params: query,
  })
}

//订单物料详情
export function orderItemDetail () {
  return request({
    url: Vue.prototype.PROFILE + '/order/itemDetail',
    method: 'GET',
    params: query,
  })
}

export function queryShopsDeliveryList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/delivery/order/queryShopsDeliveryList',
    method: 'GET',
    params: query
  })
}

export function returnList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/order/return/list',
    method: 'GET',
    params: query
  })
}

export function orderReturn (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/delivery/order/orderReturn',
    method: 'POST',
    data: query,
  })
}

export function orderSign (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/delivery/order/sign',
    method: 'POST',
    data: query,
  })
}

export function stockCheckList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/list',
    method: 'GET',
    params: query
  })
}

export function queryStockCheckItemById (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/queryStockCheckItemById',
    method: 'GET',
    params: query
  })
}

export function getShopsCheckGoodsByYKc (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/getShopsCheckGoodsByYKc',
    method: 'GET',
    params: query
  })
}

export function getShopsCheckGoods (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/getShopsCheckGoods',
    method: 'POST',
    data: query
  })
}
export function checkBill () {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/checkBill',
    method: 'GET',
  })
}

export function queryTypeList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/queryTypeList',
    method: 'GET',
    params: query
  })
}



export function verificationStockCheckItem (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/verificationStockCheckItem',
    method: 'POST',
    data: query,
  })
}

export function stockCheckAdd (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/add',
    method: 'POST',
    data: query,
  })
}

export function stockCheckEdit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/edit',
    method: 'POST',
    data: query,
  })
}

export function stockCheckDel (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/delete',
    method: 'POST',
    data: query,
  })
}

export function stockCheckAudit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/stockCheck/auditStockCheckByIds',
    method: 'POST',
    data: query,
  })
}

export function purchaseList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/list',
    method: 'GET',
    params: query
  })
}

export function supplierListToShops (query) {
  return request({
    url: Vue.prototype.PROFILE + '/supplier/supplierListToShops',
    method: 'GET',
    params: query
  })
}

export function supplierList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/supplier/supplierList',
    method: 'GET',
    params: query
  })
}

export function factoryList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/factory/list',
    method: 'GET',
    params: query
  })
}

export function purchaseAdd (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/add',
    method: 'POST',
    data: query,
  })
}

export function purchaseQueryById (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/queryById',
    method: 'GET',
    params: query
  })
}

export function purchaseEdit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/edit',
    method: 'POST',
    data: query,
  })
}

export function purchaseDelBatch (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/deleteBatch',
    method: 'POST',
    data: query,
  })
}

export function purchaseDel (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/delete',
    method: 'POST',
    data: query,
  })
}

export function purchaseAudit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/purchase/audit',
    method: 'POST',
    data: query,
  })
}
//退货单
export function returnListByShop (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/listByShop',
    method: 'GET',
    params: query
  })
}
//退货单
export function paymentList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/payment/list',
    method: 'GET',
    params: query
  })
}

export function billAppraiseAdd (query) {
  return request({
    url: Vue.prototype.PROFILE + '/billAppraise/add',
    method: 'POST',
    data: query,
  })
}
export function returnAdd (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/add',
    method: 'POST',
    data: query,
  })
}
export function returnEdit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/edit',
    method: 'POST',
    data: query,
  })
}

export function returnAudit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/audit',
    method: 'POST',
    data: query,
  })
}

export function returnQueryById (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/queryById',
    method: 'GET',
    params: query
  })
}

export function returnQueryJdlReturnBByBillId (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/queryJdlReturnBByBillId',
    method: 'GET',
    params: query
  })
}

export function returnDelBatch (query) {
  return request({
    url: Vue.prototype.PROFILE + '/return/deleteBatch',
    method: 'POST',
    data: query,
  })
}


//费用单
export function feeOrderList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/fee/order/list',
    method: 'GET',
    params: query
  })
}

export function goodsNotPricePageList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/goods/goodsNotPricePageList',
    method: 'GET',
    params: query
  })
}

export function transferQueryMyPageList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/queryMyPageList',
    method: 'GET',
    params: query
  })
}

export function transferQueryToPageList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/queryToPageList',
    method: 'GET',
    params: query
  })
}

export function transferDelBatch (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/deleteBatch',
    method: 'POST',
    data: query,
  })
}

export function transferAudit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/audit',
    method: 'POST',
    data: query,
  })
}

export function transferSign (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/sign',
    method: 'POST',
    data: query,
  })
}

export function transferAdd (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/add',
    method: 'POST',
    data: query,
  })
}

export function transferEdit (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/edit',
    method: 'POST',
    data: query,
  })
}

export function transferQueryById (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/queryById',
    method: 'GET',
    params: query
  })
}

export function shopsListToZy (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/shopsListToZy',
    method: 'GET',
    params: query
  })
}

export function getShopsGoodsKc (query) {
  return request({
    url: Vue.prototype.PROFILE + '/transfer/getShopsGoodsKc',
    method: 'POST',
    data: query,
  })
}

export function getShopsGoodsStock () {
  return request({
    url: Vue.prototype.PROFILE + '/shops/getShopsGoodsStock',
    method: 'POST'
  })
}

export function getShopsNcStock (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/getShopsNcStock',
    method: 'POST',
    data: query,
  })
}


export function confirmPay (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/order/confirmPay',
    method: 'POST',
    data: query,
  })
}
export function shopsConfig () {
  return request({
    url: Vue.prototype.PROFILE + '/shops/config',
    method: 'GET',
  })
}

export function sysConfig (query) {
  return request({
    url:  '/system/sysConfig/list',
    method: 'GET',
    params: query,
  })
}

//汇总支付订单
export function orderMainList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/orderMain/queryShopsOrderMainList',
    method: 'GET',
    params: query
  })
}


export function queryShopsOrderList (query) {
  return request({
    url: Vue.prototype.PROFILE + 'shops/order/queryShopsOrderList',
    method: 'GET',
    params: query,
  })
}

export function mainOrderPayStatus (query) {
  return request({
    url: Vue.prototype.PROFILE + 'cmbOrder/orderPayStatusQuery',
    method: 'POST',
    data: query
  })
}

export function mainOrderCCBPayStatus (query) {
  return request({
    url: Vue.prototype.PROFILE + '/shops/order/confirmMainOrderPay',
    method: 'POST',
    data: query
  })
}

export function orderMainCancel (data) {
  return request({
    url: Vue.prototype.PROFILE + 'shops/orderMain/cancel',
    method: 'POST',
    data: data
  })
}

export function zhsfmxSupplierList (data) {
  return request({
    url: Vue.prototype.PROFILE + 'shops/delivery/order/orderSfmxDetail',
    method: 'POST',
    data: data
  })
}

export function bankShop(data){
  return request({
    url: Vue.prototype.PROFILE + 'jdlBankShopsPlan/getBankShopByShopCode',
    method: 'GET',
    params: data
  })
}










// WEBPACK FOOTER //
// ./src/api/order.js